import { Component } from '@angular/core';

@Component({
    selector: 'app-custombreadcrumb',
    templateUrl: './custombreadcrumb.component.html',
    styleUrls: ['./custombreadcrumb.component.scss'],
    standalone: false
})
export class CustombreadcrumbComponent {

}
